export default {
	description: "Учётные периоды складского учёта",
	access: {
		read: true,
		create: true,
		update: true,
		delete: true
	},
	forms: {
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false,
							hide: true
						}
					},
					warehouse_id: {
						description: 'Склад (подразделение)'
					},
					year: {
						description: 'Год',
						config: {
							width: '100px'
						}
					},
					month: {
						description: 'Месяц',
						config: {
							width: '120px'
						}
					},
					status: {
						description: 'Статус',
						config: {
							width: '100px'
						}
					},
					opened_at: {
						description: 'Дата открытия',
						config: {
							width: '160px'
						}
					},
					closed_at: {
						description: 'Дата закрытия',
						config: {
							width: '160px'
						}
					},
					comment: {
						description: 'Комментарий',
						config: {
							width: '200px'
						}
					}
				}
			}
		}
	}
}
